import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useEffectEvent } from "react";

const GET_ORGANIZATION_DEFAULT_TEMPLATES = gql`
  query GetOrganizationDefaultTemplates($orgUuid: String!) {
    organization(uuid: $orgUuid) {
      uuid
      defaultTemplates {
        uuid
        name
        templateType
        description
        isFavourite
        sharingType
        teamDefaults
        createdAt
        updatedAt
        user {
          uuid
          firstName
          lastName
          teams {
            organization {
              uuid
            }
            uuid
            name
          }
        }
      }
    }
  }
`;

export const useOrgDefaultTemplates = (orgUuid: string | null) => {
  const [
    fetchOrgDefaults,
    { data, loading, error, refetch, called },
  ] = useLazyQuery(GET_ORGANIZATION_DEFAULT_TEMPLATES);

  const fetchOrgDefaultsEvent = useEffectEvent(() => {
    fetchOrgDefaults({ variables: { orgUuid } });
  });

  useEffect(() => {
    if (orgUuid) {
      fetchOrgDefaultsEvent();
    }
  }, [orgUuid]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const typedData = data as any;

  const safeRefetch = () => {
    if (!orgUuid) {
      return;
    }
    if (called) {
      refetch({ orgUuid });
    } else {
      fetchOrgDefaults({ variables: { orgUuid } });
    }
  };

  return {
    organization: typedData?.organization || null,
    defaultTemplates: typedData?.organization?.defaultTemplates || [],
    loading,
    error,
    refetch: safeRefetch,
  };
};
